import { Fragment, useCallback, useEffect, useState } from 'react';

import { Footer } from '@/components/Footer';
import type { ContentfulFooterFragment } from '@/graphql/contentful/api';
import { useRouter } from '@/hooks/useRouter';
import {
  fetchCMSDefaultLayoutData,
  fetchFixedPageData,
  generateSectionKey,
  renderContentfulFixedPage,
} from '@/integrations/contentful';
import type { ContentfulFixedPageCMSData } from '@/integrations/contentful/types';
import { getGqlRegionFromLocale, getRegionFromLocale } from '@/lib/regions';
import { EmptyShoppingBagContent } from '@/views/ShoppingBagView/components/EmptyShoppingBag/EmptyShoppingBagContent';

import * as S from './EmptyShoppingBagMobile.styles';

export const EmptyShoppingBagMobile = () => {
  const [cmsData, setCmsData] = useState<ContentfulFixedPageCMSData>();
  const [defaultLayoutData, setDefaultLayoutData] = useState<
    ContentfulFooterFragment | null | undefined
  >();
  const { locale: routerLocale } = useRouter();

  const fetchData = useCallback(async () => {
    const { channel, languageCode } = getGqlRegionFromLocale(routerLocale);
    const { country, locale } = getRegionFromLocale(routerLocale);
    const countryCode = country.slug;
    const data = await fetchFixedPageData(
      'store/shopping-bag',
      locale.locale,
      languageCode,
      channel,
      countryCode,
    );
    setCmsData(data.cms);
    const defaultLayout = await fetchCMSDefaultLayoutData(
      locale,
      country,
      true,
    );
    setDefaultLayoutData(defaultLayout?.footer);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <S.EmptyBagWrapper className='empty-shopping-bag'>
      <S.BagAndTextWrapper>
        <EmptyShoppingBagContent />
      </S.BagAndTextWrapper>
      {cmsData?.bottomContent?.map((data, i) => {
        return (
          <Fragment key={generateSectionKey(data, i)}>
            {renderContentfulFixedPage(
              data,
              undefined,
              cmsData.cmsExtraData,
              false,
            )}
          </Fragment>
        );
      })}
      {defaultLayoutData && (
        <Footer
          data-test-id='MobileDrawerFooter'
          disableListenEvent={true}
          footerData={defaultLayoutData ?? {}}
        />
      )}
    </S.EmptyBagWrapper>
  );
};

export default EmptyShoppingBagMobile;
